var ezdia;
(function (ezdia) {
    var NAME = 'segments';
    var TYPE = 'segments';
    var DATA_TYPE = "ez." + TYPE;
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var idPrefix = 'ez_js_sys_variation_';
    var defaultEdConfig = {
        toolbar: [],
        plugins: ['mention'],
        menubar: false,
        statusbar: false,
        branding: false
    };
    var DEFAULT = {
        localStorage: false,
        value: null,
        toggleTemplate: ezdia.templates.segments.toggleTemplate
    };
    var Segments = /** @class */ (function () {
        function Segments(elem, options) {
            this.elem = elem;
            this.init(options);
        }
        Object.defineProperty(Segments.prototype, "Defaults", {
            get: function () {
                return DEFAULT;
            },
            enumerable: false,
            configurable: true
        });
        Segments.prototype.setValue = function (value) {
            var cache = this.cache;
            var visibleValue = this.getHighlightedVal(value, cache);
            cache.helement.val(value);
            cache.ed.setContent(visibleValue);
        };
        Segments.prototype.getValue = function () {
            return this.cache.helement.val();
        };
        Segments.prototype.destroy = function () {
            //
        };
        Segments.prototype.getOptions = function (options) {
            return __assign(__assign(__assign({}, DEFAULT), this.$elem.data()), options);
        };
        Segments.prototype.init = function (options) {
            this.id = this.elem.id;
            this.name = this.elem.name;
            this.$elem = $(this.elem);
            this.options = this.getOptions(options);
            this.cache = this.setCache();
            this.render();
        };
        Segments.prototype.render = function () {
            this.createEditor();
            this.action();
        };
        Segments.prototype.toggle = function () {
            var ed = tinymce.get(this.id);
            var elem = this.id;
            var height = ed.settings.height;
            var template = this.options.toggleTemplate;
            var editor = $("#" + elem).css('height', height);
            var context = {
                id: "ez-tab-" + elem
            };
            if (this.version === 3) {
                editor.before(template(context));
            }
            else {
                $("[name=\"" + elem + "\"]").after(template(context));
            }
            $("#" + context.id).on('click', 'a', function click() {
                $(this).addClass('active').siblings().removeClass('active');
                tinymce.execCommand('mceToggleEditor', false, elem);
            });
            $("#" + elem).on('blur', function blur() {
                if (this.offsetParent !== null) {
                    var content = this.value;
                    ed.setContent(content);
                }
            });
        };
        Segments.prototype.createEditor = function () {
            var edConfig = {};
            if (ezdia.util.getEditor(this.elem.id)) {
                delete tinymce.editors[this.elem.id];
            }
            edConfig = this.getConfig();
            this.$elem.tinymce(edConfig);
            this.validate();
            this.updateUrl();
            this.toggle();
        };
        Segments.prototype.updateUrl = function () {
            var _this = this;
            var self = this;
            var urlParam = this.cache.urlParam;
            this.query = [];
            if (urlParam && urlParam.reference) {
                $.each(urlParam.reference, function (i, obj) {
                    var elem = $("[name=" + obj.name + "]") || $("#" + obj.name);
                    var value;
                    var query = '';
                    if (!elem.length) {
                        value = $("#" + obj.name).text() || '';
                        value = value.trim();
                    }
                    else {
                        value = elem.val() || '';
                        _this.bindQueryChange({
                            elem: elem,
                            searchKey: obj.searchKey,
                            index: i
                        });
                    }
                    query = obj.searchKey + "=" + value;
                    self.query.push(query);
                });
            }
            this.setUrl();
        };
        Segments.prototype.getConfig = function () {
            var _this = this;
            var config = $.extend(true, {}, {}, defaultEdConfig);
            config.setup = function (ed) {
                ed.on('Init', function () {
                    _this.cache.ed = ed;
                    _this.setprop(ed);
                });
                ed.on('postRender', function () {
                    ed.on('blur', function () {
                        _this.$elem.data('event', 'blur').valid();
                        _this.$elem.data('event', '');
                        _this.updateContent(ed);
                    });
                });
            };
            config.mentions = this.getmentionsConfig();
            return config;
        };
        Segments.prototype.getmentionsConfig = function () {
            var config = this.options.column.config || {};
            var highlight = config.highlight, _a = config.limit, limit = _a === void 0 ? 10 : _a;
            var wrap = null;
            if (highlight) {
                wrap = $(highlight.wrap);
            }
            return {
                delimiter: ['{'],
                items: limit,
                source: $.proxy(source, this),
                insert: function (item) {
                    var expression = "{{{" + item.name + "}}}";
                    if (wrap) {
                        expression = wrap.html(expression).prop('outerHTML') + "&nbsp;";
                    }
                    return expression;
                }
            };
        };
        Segments.prototype.getReqParam = function () {
            var cache = this.cache;
            var value = cache.helement.val() || '';
            var error = false;
            var reqParam = '';
            if (cache.requireds.length) {
                // eslint-disable-next-line consistent-return
                $.each(cache.requireds, function (i, mobj) {
                    var values = mobj.element.value;
                    if (values) {
                        reqParam += (reqParam && '&') + mobj.searchKey + "=" + values;
                    }
                    else {
                        error = mobj.label;
                        return false;
                    }
                });
            }
            if (!value.trim() || error) {
                this.errorDialog(error || cache.label);
                reqParam = false;
            }
            else {
                if (cache.regex) {
                    value = this.getHighlightedVal(value, cache);
                }
                reqParam += (reqParam && '&') + "segment=" + value;
            }
            return reqParam;
        };
        Segments.prototype.getHighlightedVal = function (value, cache) {
            var regex = cache.regex;
            var matchArray = value.match(regex) || [];
            $.each(matchArray, function (i, reg) {
                var highlight = $(cache.highlight).text(reg).prop('outerHTML');
                // eslint-disable-next-line no-param-reassign
                value = value.replace(reg, highlight);
            });
            return value.replace(/&nbsp;/g, ' ');
        };
        Segments.prototype.setprop = function (ed) {
            var url = ed.baseURI.source;
            ed.dom.loadCSS(url + "/plugins/ezdia/css/bootstrap.min.css");
            ed.dom.loadCSS(url + "/plugins/ezdia/css/ezdia.css");
            ed.iframeElement.title = '';
            ed.contentAreaContainer.style.borderWidth = 0;
        };
        Segments.prototype.setUrl = function () {
            var querySeparator = '?';
            var url = this.options.column.config.url;
            if (url.includes('?')) {
                querySeparator = '&';
            }
            if (this.query.length) {
                url += querySeparator + this.query.join('&') + "&term=";
            }
            else {
                url += querySeparator + "term=";
            }
            this.cache.url = url;
        };
        Segments.prototype.updateContent = function (ed) {
            var content = ed.getContent({ format: 'text' });
            this.cache.helement.val(content).trigger('change');
        };
        Segments.prototype.validate = function () {
            var frm = this.elem.form;
            var $frm = $(frm);
            var isFormValidator = $frm.data('validator');
            if (!isFormValidator) {
                $.ezdia.validate.create({}, $frm);
            }
            this.$elem.rules('add', {
                handlebars: true
            });
        };
        Segments.prototype.setCache = function () {
            var e_1, _a;
            var column = this.options.column;
            var name = column.name;
            var config = column.config || {};
            var highlight = config.highlight || {};
            var urlParam = config.urlParam;
            var reqArray = [];
            var regex = null;
            if (urlParam) {
                try {
                    for (var _b = __values(urlParam.reference), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var ref = _c.value;
                        var required = ref.required, searchKey = ref.searchKey;
                        if (required) {
                            var elem = $("[name=" + name + "]");
                            var label = elem.closest('[data-row="row"]').find('.control-label').text() ||
                                '';
                            if (elem.length) {
                                reqArray.push({
                                    element: elem[0],
                                    searchKey: searchKey,
                                    label: label || name
                                });
                            }
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            if (highlight.regex) {
                regex = new RegExp(highlight.regex, 'g');
            }
            var ret = {
                helement: $("[name=" + name + "]"),
                ed: null,
                url: null,
                label: column.label,
                variations_wrapper: $("#" + idPrefix + "wrap_" + name).hide(),
                errors_wrapper: $("#" + idPrefix + "error_" + name).hide(),
                requireds: reqArray,
                regex: regex,
                highlight: highlight.wrap,
                urlParam: urlParam
            };
            return ret;
        };
        Segments.prototype.showVariation = function (response) {
            var content = '';
            var errors = '';
            if (response.success) {
                $.each(response.data.variations_data, function (i, mval) {
                    content += "<p>" + mval + "</p>";
                });
                if (response.data.quality_check_data) {
                    errors = '<b>Grammar Check Error</b><br><br>';
                    errors += '<b>Suggestion(s):-</b><br><br>';
                    $.each(response.data.quality_check_data, function (i, mval) {
                        errors += "<p>" + mval + "</p>";
                    });
                }
            }
            else {
                content = response.msg;
            }
            this.cache.variations_wrapper.html(content).show();
            this.cache.errors_wrapper.html('').hide();
            if (response.data && response.data.quality_check_data) {
                this.cache.errors_wrapper.html(errors).show();
            }
        };
        Segments.prototype.errorDialog = function (label) {
            var wrap = $.ezdia.getWrapper(idPrefix + "error_dialog");
            var msg = "<b>" + label + "</b> field is required.";
            wrap.html(msg);
            wrap.dialog({
                closeOnEscape: false,
                open: function (e, ui) {
                    // tslint:disable-next-line:no-bitwise
                    $('.ui-dialog-titlebar-close', ui.dialog || ui).hide();
                },
                modal: true,
                title: 'Generate variations error',
                width: 300,
                height: 150,
                buttons: {
                    Close: function () {
                        $(this).dialog('close');
                    }
                }
            });
        };
        // ACTIONS FUNCTIONS
        // =========================
        Segments.prototype.action = function () {
            var column = this.options.column;
            var self = this;
            $("#" + idPrefix + column.name).on("click." + TYPE, function click() {
                generateVariation.call(self, this);
            });
        };
        Segments.prototype.bindQueryChange = function (obj) {
            var self = this;
            obj.elem.on('change', function change() {
                var value = this.value;
                var query = obj.searchKey + "=" + value;
                self.query[obj.index] = query;
                self.setUrl();
            });
        };
        return Segments;
    }());
    var processData = function (arr) {
        var opt = [];
        opt = $.map(arr, function (objm) { return ({
            name: objm.value
        }); });
        return opt;
    };
    // AJAX FUNCTIONS
    // =========================
    function source(query, process) {
        var url = this.cache.url;
        $.ajax({
            type: 'POST',
            url: url + query,
            dataType: 'json',
            async: false,
            success: function (response) {
                var optionsArray = processData(response);
                process(optionsArray);
            }
        });
    }
    function generateVariation(element) {
        var self = this;
        var elem = $(element);
        var reqParam = this.getReqParam();
        var url = 'getVariation.htm?';
        var isDisabled = elem.hasClass('disabled');
        if (!reqParam || isDisabled) {
            return;
        }
        elem.addClass('selected');
        $.ajax({
            type: 'POST',
            url: url + reqParam,
            dataType: 'json',
            async: false,
            success: function (response) {
                self.showVariation(response);
            }
        });
    }
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */
    var publicMethods = {
        setValue: Segments.prototype.setValue,
        getValue: Segments.prototype.getValue,
        destroy: Segments.prototype.destroy
    };
    function jQueryInterface(option) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof option === 'string' && option !== 'destroy') {
            return invokePublicMethod.call(this, option, args);
        }
        return createNewInstance.call(this, option);
    }
    function invokePublicMethod(methodName, args) {
        if (publicMethods[methodName]) {
            var inputObject = retrieveObjectFromElement(this);
            var result = publicMethods[methodName].apply(inputObject, args);
            if (typeof result === 'undefined') {
                return $(this);
            }
            return result;
        }
        throw new Error("method '" + methodName + "()' does not exist for input list.");
    }
    // eslint-disable-next-line consistent-return
    function retrieveObjectFromElement(element) {
        var inputObject = $(element).data(DATA_TYPE);
        if (inputObject && inputObject instanceof Segments) {
            return inputObject;
        }
    }
    function createNewInstance(option) {
        var $this = $(this);
        $this.each(function each() {
            var self = $(this);
            var data = self.data(DATA_TYPE);
            var options = typeof option === 'object' && option;
            if (!data) {
                self.data(DATA_TYPE, (data = new Segments(this, options)));
            }
            if (typeof option === 'string') {
                data[option]();
            }
        });
        return $this;
    }
    $.fn[NAME] = jQueryInterface;
    $.fn[NAME].Constructor = Segments;
    $.fn[NAME].noConflict = function noConflict() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return jQueryInterface;
    };
})(ezdia || (ezdia = {}));
